import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import PersonFullName from '/component/partial/report/PersonFullName';
import ReferralExpirationDate from '/component/partial/report/ReferralExpirationDate';
import {Reports} from '/constant/TestIDs';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ReferralRecordExpiration.style';

interface ReferralRecordExpirationProps {
  item: any;
}

const ReferralRecordExpiration: React.FC<ReferralRecordExpirationProps> = ({
  item,
}) => {
  const expirationTime = get(item, 'expirationTime', '');
  const fullName = PersonFullName({item});

  const expirationIdentifier = (receivedDate: string): boolean => {
    try {
      const dateUtil = getDateUtilDefaultInstance();
      const parsed = dateUtil.parseEasternDate(receivedDate);
      if (!parsed || isNaN(parsed.getTime())) {
        // fallback policy: treat invalid as expired
        return true;
      }
      return Date.now() > parsed.getTime();
    } catch (err) {
      // on error, treat as expired
      return true;
    }
  };

  const isExpired = expirationIdentifier(expirationTime);

  return (
    <View accessible={false}>
      <View
        style={styles.nameWarningWrapper}
        accessible={true}
        accessibilityLabel={fullName}
        {...testProperties(Reports.reportClientFullName)}>
        <Text style={styles.nameText} accessible={false}>
          {fullName}
        </Text>
        {isExpired && (
          <Icon
            name="alert"
            style={styles.alertButtonIcon}
            accessible={false}
          />
        )}
      </View>
      <ReferralExpirationDate item={item} isExpired={isExpired} />
    </View>
  );
};

export default ReferralRecordExpiration;
